import type { JSX } from "react";
import { useEffect } from "react";
import { useTranscriptionStreamingStore } from "@/store/transcriptionStreaming.store";
import { TranscriptionList } from "./TranscriptionList";

export const TranscriptionStreamingList = (): JSX.Element => {
  const {
    transcriptionStreamText,
    isLoading,
    partialText,
    gaps,
    resetStreamText,
  } = useTranscriptionStreamingStore();

  useEffect(() => {
    resetStreamText();
  }, [resetStreamText]);

  return (
    <TranscriptionList
      gaps={gaps}
      loading={isLoading}
      partialText={partialText}
      transcriptions={transcriptionStreamText}
    />
  );
};
